import axiosInstance from './axiosConfig';

export interface OrderItem {
  subcategoryId: string;
  name: string;
  image?: string;
  price: number | null;
  quantity: number;
}

export interface Order {
  id: string;
  orderNumber: string;
  customer: {
    name: string;
    phone: string;
    email: string;
    company?: string;
  };
  comment?: string;
  items: OrderItem[];
  total: number;
  status: string;
  statusLabel: string;
  createdAt: string;
}

export async function createOrder(payload: {
  items: Array<{ subcategoryId: string; quantity: number }>;
  comment?: string;
  customer: {
    name: string;
    phone: string;
    email: string;
    company?: string;
  };
}): Promise<Order> {
  const response = await axiosInstance.post('/orders', payload);
  return response.data;
}

export async function fetchMyOrders(): Promise<Order[]> {
  const response = await axiosInstance.get('/orders/my');
  return response.data;
}
